import { createFileRoute } from '@tanstack/react-router';
import { LoanModule } from '@/modules/loan';

export const Route = createFileRoute('/(dashboard)/_dashboard/loan/')({
  component: LoanModule,
});
